import { render, staticRenderFns } from "./input-recipients.vue?vue&type=template&id=03e9c6f9&"
import script from "./input-recipients.vue?vue&type=script&lang=js&"
export * from "./input-recipients.vue?vue&type=script&lang=js&"
import style0 from "./input-recipients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports